<script>
// const BASE_URL = "/api"; // 跨域代理
const BASE_URL = "https://ccadmin.ccndt.cc"; 
const IMAGE_URL = "https://images.ccndt.cc/uploads/";
export default {
  BASE_URL,
  IMAGE_URL,
};
</script>
